import { RepaymentMethod } from '../models/RepaymentMethod';

export const getRepaymentMethods: () => RepaymentMethod[] = (): RepaymentMethod[] => ([
    RepaymentMethod.DirectDebit,
    RepaymentMethod.Paper
]);
